/**
 * Kompletność i akceptacja prezlecenia — do pokazania każdemu, kto je ogląda.
 *
 * Analiza Administracji §6.4: „uprawnieni użytkownicy mogą podejrzeć rekord
 * w toku i jego stan kompletności”; CS §11.2: rolą prezlecenia jest „wskazanie
 * braków, a nie udawanie kompletności”. Reguł tu nie ma — lista braków
 * przychodzi z API (`missingFields`, liczona przy każdym zapisie z
 * `REQUIRED_FIELDS` w `pre-order/manual-entry.ts`), a akceptacja to
 * `acceptedAt` / `acceptedBy`. Pełna macierz pól obowiązkowych jest kwestią
 * otwartą (CS §17 pkt 2, Administracja §17) — dopóki jej nie ma, nie
 * dokładamy własnych.
 */

/** Nazwy kolumn z `missingFields` po ludzku — te same, co w API. */
const MISSING_FIELD_LABELS: Record<string, string> = {
  companyId: 'spółka',
  clientName: 'klient',
  loadingCity: 'miasto załadunku',
  unloadingCity: 'miasto rozładunku',
  loadingDate: 'data załadunku',
  unloadingDate: 'data rozładunku',
};

/** Nieznanej nazwy nie gubimy — pokazujemy ją, jak przyszła. */
export function missingFieldLabel(name: string): string {
  return MISSING_FIELD_LABELS[name] ?? name;
}

export interface PreOrderReadiness {
  /** Braki do akceptacji, po ludzku, w kolejności z API. */
  missing: string[];
  accepted: boolean;
  acceptedBy: string | null;
  acceptedAt: string | null;
}

export function preOrderReadiness(r: Record<string, unknown>): PreOrderReadiness {
  const raw = Array.isArray(r.missingFields) ? (r.missingFields as unknown[]) : [];
  return {
    missing: raw.map((m) => missingFieldLabel(String(m))),
    accepted: r.acceptedAt != null,
    acceptedBy: typeof r.acceptedBy === 'string' && r.acceptedBy !== '' ? r.acceptedBy : null,
    acceptedAt: typeof r.acceptedAt === 'string' ? r.acceptedAt : null,
  };
}
